<template>
	<div id="contacts-index"
		 class="app-home ui-styles"
		 :class="theme">
		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :reportOpen="reportOpen"></side-nav-bar>

				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Contacts_Index') }}</h1>

					<div>
						<div @click.prevent="onCreateNewContact" style="width: fit-content; margin-left: auto">
							<icon-button icon="plus-circle" :text="new_contact_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div class="grid-row" layout="row top-stretch">
						<div class="grid-cell" layout="row">
							<input type="text" :placeholder="filter_placeholder" self="size-x1"
								   v-model="customers.filter"
								   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
								   data-step="9" data-position="top">
						</div>
					</div>
					<div class="grid-row" layout="row top-stretch">
						<div class="grid-cell">
							<paginator :source="contacts_to_array(contacts)" :page-size="10" :filter="customers.filter"
									   data-intro="Use the paginator to page data for easier viewing" data-step="10"
									   data-position="top">
								<template scope="page">
									<datatable id="data-table-main"
											   :source="page.data"
											   :filterable="false"
											   :striped="customers.striped"
											   :editable="customers.editable"
											   :line-numbers="customers.lineNumbers">
										<datatable-column
												v-for="column in customers.columns"
												:id="column.id"
												:label="column.label"
												:width="column.width"
												:sortable="column.sortable"
												:groupable="column.groupable"
												:formatter="column.formatter">
										</datatable-column>
										<datatable-column id="actions" label="Actions" :sortable="false"
														  :groupable="false"></datatable-column>
										<!--<template slot="sel" scope="cell">
											<div class="checkable-column">
												<checkbox :id="cell.row.id" :value="cell.row" v-model="customers.selected"></checkbox>
											</div>
										</template>-->
										<template slot="actions" scope="cell">
											<a @click="editContact(cell.row)"
											   style="margin-right: 2rem; cursor: pointer;">
												<icon name="pencil" scale="1" color="gray"></icon>
											</a>
											<a @click="deleteContact(cell.row)" style="cursor: pointer;">
												<icon name="trash-o" scale="1" color="gray"></icon>
											</a>
										</template>
									</datatable>
								</template>
							</paginator>
						</div>
					</div>

					<!--
					<div>
						<h3>Custom Cell and Header Templates</h3>
						<p>
							This example shows how you can leverage the flexibility of the datatable's custom templating features to create selectable items. This technique can be used to cater for most custom templating requirements you may have.
						</p>
						<div class="grid-row" layout="row top-stretch">
							<div class="grid-cell">
								<h4>Main datatable</h4>
								<paginator :source="customers.rows" :page-size="4" :filter="customers.filter"
										   data-intro="Use the paginator to page data for easier viewing" data-step="10"
										   data-position="top">
									<template scope="page">
										<datatable id="data-table-main"
												   :source="customers.rows"
												   :striped="customers.striped"
												   :editable="customers.editable"
												   :line-numbers="customers.lineNumbers">
											<datatable-column id="sel" label="sel" width="3rem" class="checkable-column"
															  :sortable="false" :groupable="false"
															  data-intro="Use custom cell tamplates to put your own content in cells"
															  data-step="10">
												<checkbox id="sel-all" v-model="selectAll"></checkbox>
											</datatable-column>
											<datatable-column
													v-for="column in customers.columns"
													:id="column.id"
													:label="column.label"
													:width="column.width"
													:sortable="column.sortable"
													:groupable="column.groupable"
													:formatter="column.formatter">
											</datatable-column>
											<datatable-column id="actions" label="Actions" :sortable="false"
															  :groupable="false"></datatable-column>
											<template slot="sel" scope="cell">
												<div class="checkable-column">
													<checkbox :id="cell.row.id" :value="cell.row"
															  v-model="customers.selected"></checkbox>
												</div>
											</template>
											<template slot="actions" scope="cell">
												<a @click="deleteCustomer(cell.row)">Delete Customer</a>
											</template>
										</datatable>
									</template>
								</paginator>
							</div>
						</div>
						<div class="grid-row" layout="row top-stretch">
							<div class="grid-cell">
								<h4>Selected Items</h4>
								<datatable id="data-table-selected" :source="customers.selected"
										   :line-numbers="customers.lineNumbers">
									<datatable-column
											v-for="column in customers.columns"
											:id="column.id"
											:label="column.label"
											:width="column.width"
											:formatter="column.formatter">
									</datatable-column>
								</datatable>

							</div>
						</div>
					</div>
					-->
					<!--<bar>
					</bar>
-->
				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import router from '../../../router'
    import { localStorageMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    // import DatatableCell from '../../../components/Datatable/datatable-cell.js'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'contacts-index',

        mixins: [localStorageMixin],

        data: () => ({
            master_loading: true,
            filesOpen: false,
            fileOpen: false,
            reportOpen: false,
            error: null,
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            new_contact_button_text: Vue.i18n.translate('Add_contact'),
            customers: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,

                currency: 'USD',
                dateFormat: 'D MMMM YYYY',

                columns: [
                    {
                        id: 'complete_name',
                        label: Vue.i18n.translate('Complete_name'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'main_email',
                        label: 'E-mail',
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'tin',
                        label: Vue.i18n.translate('TIN'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                    /*
                    {
                        id: 'name',
                        label: Vue.i18n.translate('Name'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'surnames',
                        label: Vue.i18n.translate('Surnames'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                    */
                ],

                rows: [
                    {
                        id: '0584e8d2-984c-4ce0-a20f-8b9e21cd2c00',
                        name: 'Nancy Fuller',
                        purchasor_email: 'nfuller0@about.me',
                        purchase_date: '2002-01-02T04:45:48Z',
                        purchase_amount: 1166.14
                    },
                    {
                        id: 'f4769183-38af-4c22-8383-6dea302466fd',
                        name: 'Melissa Meyer',
                        purchasor_email: 'mmeyer1@angelfire.com',
                        purchase_date: '2010-05-15T08:13:59Z',
                        purchase_amount: 6123.50
                    },
                    {
                        id: 'e171c9fb-2438-4f23-8d0d-011b2d8e95bc',
                        name: 'Larry Rose',
                        purchasor_email: 'lrose2@cdbaby.com',
                        purchase_date: '2014-11-23T09:18:18Z',
                        purchase_amount: 8288.27
                    },
                    {
                        id: '3cad078d-083b-416e-9dd4-2f1470c3458d',
                        name: 'Jack Simpson',
                        purchasor_email: 'jsimpson3@mayoclinic.com',
                        purchase_date: '2002-01-02T04:45:48Z',
                        purchase_amount: 1215.03
                    },
                    {
                        id: 'ef7ff12c-90e5-4bfb-8fdd-9f20e4206afa',
                        name: 'Ernest Watson',
                        purchasor_email: 'ewatson4@nytimes.com',
                        purchase_date: '2002-01-02T04:45:48Z',
                        purchase_amount: 9455.16
                    },
                    {
                        id: 'b243be08-6b9c-4ebd-bb8b-b59256ad4956',
                        name: 'Adam Castillo',
                        purchasor_email: 'acastillo5@dailymotion.com',
                        purchase_date: '2014-08-22T08:14:28Z',
                        purchase_amount: 9988.45
                    },
                    {
                        id: 'a491adf5-8129-4f93-9442-98522fbd1e90',
                        name: 'Wayne Wilson',
                        purchasor_email: 'wwilson6@indiegogo.com',
                        purchase_date: '2012-03-07T22:16:08Z',
                        purchase_amount: 4563.87
                    },
                    {
                        id: '497a6cca-5c9c-4b93-af8e-63c93de3eacf',
                        name: 'Roy Coleman',
                        purchasor_email: 'rcoleman7@independent.co.uk',
                        purchase_date: '2010-09-14T05:05:17Z',
                        purchase_amount: 4563.87
                    },
                    {
                        id: 'ea34a698-fb86-44a5-b80e-57087d48737c',
                        name: 'Betty Diaz',
                        purchasor_email: 'bdiaz8@dropbox.com',
                        purchase_date: '2012-03-07T22:16:08Z',
                        purchase_amount: 7527.62
                    },
                    {
                        id: 'c48e5e68-cae5-4a2e-96b2-8509fca19ddb',
                        name: 'Sharon Gardner',
                        purchasor_email: 'sgardner9@seesaa.net',
                        purchase_date: '2004-10-14T14:59:00Z',
                        purchase_amount: 1166.14
                    }
                ],

                selected: []
            }
        }),

        created () {
            this.FETCH_CONTACTS()
                .then(() => {
                    this.master_loading = false
                })
        },

        components: {
            Bar,
            Checkbox,
            Datatable,
            DatatableColumn,
            IconButton,
            Paginator,
            Spinner,
			SideNavBar
        },
        computed: {
            ...mapGetters([
                'contacts',
                'theme',
            ]),
            selectAll: {
                get: function () {
                    return this.customers.selected.length === this.customers.rows.length
                },
                set: function (value) {
                    this.customers.selected = value ? this.customers.rows : []
                }
            }
        },
        methods: {
            ...mapActions([
                'CREATE_NEW_CONTACT',
                'DELETE_CONTACT',
                'EDIT_CONTACT',
                'FETCH_CONTACTS',
                'SET_CONTACT'
            ]),
            onCreateNewContact: function () {
                this.CREATE_NEW_CONTACT({path: 'contacts', creating_from_main: true}).then((res) => {
                    this.$router.push({name: 'contact-editor'})
                })
            },
            contacts_to_array: function (object) {
                return _.values(object)
            },
            editContact: function (contact) {
                console.log('edit...')
                this.SET_CONTACT({path: 'contacts' + '/' + contact.id}).then((res) => {
                    this.$router.push({name: 'contact-editor', query: {id: contact.id}})

                })
            },
            deleteContact: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete') + ' "' + entity.complete_name + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_CONTACT({
                        path: 'contacts' + '/' + entity.id,
                        key: entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_CONTACTS()
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            }
        },

        /*
		 watch: {
		 contacts: {
		 handler: function (val, oldVal) {
		 console.log('a thing changed')
		 },
		 deep: true
		 }
		 },
		 */

        head: {
            title: {
                //inner: Vue.i18n.translate('Contacts_Index')
                inner: 'Contacts Index'
            }
        }

    }
</script>



// WEBPACK FOOTER //
// ContactsIndex.vue?7f3da302